import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	rollUpStatusToDo: {
		id: 'fastshift.dashboard.roll-up-status.to-do',
		defaultMessage: 'TO DO',
		description: 'Status label for TO_DO status',
	},
	rollUpStatusOnTrack: {
		id: 'fastshift.dashboard.roll-up-status.on-track',
		defaultMessage: 'ON TRACK',
		description: 'Status label for ON_TRACK status',
	},
	rollUpStatusComplete: {
		id: 'fastshift.dashboard.roll-up-status.complete',
		defaultMessage: 'COMPLETED',
		description: 'Status label for COMPLETE status',
	},
	rollUpStatusAtRiskAtlassianOwned: {
		id: 'fastshift.dashboard.roll-up-status.at-risk-atlassian-owned',
		defaultMessage: 'AT RISK - OWNED BY ATLASSIAN',
		description: 'Status label for AT_RISK_ATLASSIAN_OWNED status',
	},
	rollUpStatusAtRiskPartnerOwned: {
		id: 'fastshift.dashboard.roll-up-status.at-risk-partner-owned',
		defaultMessage: 'AT RISK - OWNED BY PARTNER',
		description: 'Status label for AT_RISK_PARTNER_OWNED status',
	},
	rollUpStatusNeedsCustomerAttention: {
		id: 'fastshift.dashboard.roll-up-status.needs-customer-attention',
		defaultMessage: 'NEEDS CUSTOMER ATTENTION',
		description: 'Status label for NEEDS_CUSTOMER_ATTENTION status',
	},
	rollUpStatusNeedsAttention: {
		id: 'fastshift.dashboard.roll-up-status.needs-attention',
		defaultMessage: 'NEEDS ATTENTION',
		description: 'Status label for NEEDS_ATTENTION status',
	},
	rollUpStatusUnknown: {
		id: 'fastshift.dashboard.roll-up-status.unknown',
		defaultMessage: 'UNKNOWN STATUS',
		description: 'Fallback status label for unknown status values to prevent UI crashes',
	},
});
